import * as React from 'react';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, createTheme } from '@material-ui/core';
import { ThemeProvider, withStyles } from '@material-ui/core/styles';
import { fontFamilies } from '../../theme/text';

interface Props {
  values: any[];
  options: string[];
  title: string;
  selectedValue: any;
  handleChange: (val) => void;
}

const materialTheme = createTheme({
  overrides: {
    // @ts-ignore
    MuiFormControlLabel: {
      label: {
        fontFamily: fontFamilies.body,
        fontWeight: 300,
        fontSize: 14,
        letterSpacing: '0.3px',
        color: '#000000'
      }
    },
    MuiFormLabel: {
      root: {
        fontFamily: fontFamilies.heading,
        fontWeight: 300,
        color: '#4f4f4f !important',
        fontSize: 11
      }
    },
    MuiRadio: {
      colorSecondary: {
        color: '#d1cece',
        '&$checked': {
          color: '#006da8',
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      }
    },
    MuiSvgIcon: {
      root: {
        width: 20,
        height: 20,
        '&:hover': {
          fill: '#006da8 !important'
        }
      }
    }
  }
});

const StyledRadioForm = withStyles({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked ': {
      color: '#006da8'
    },
    '& .MuiIconButton-colorSecondary:hover': {
      backgroundColor: 'transparent',
      '& svg': {
        '& path': {
          fill: '#00aafc !important'
        }
      }
    },
    '& .MuiIconButton-colorSecondary.Mui-disabled': {
      backgroundColor: 'transparent',
      '& svg': {
        backgroundColor: '#8a8a8a',
        borderRadius: 10,
        width: 16,
        height: 16,
        margin: 2,
        '& path': {
          fill: '#8a8a8a'
        }
      }
    }
  }
})(FormControl);

const RadioForm = ({ values, options, title, selectedValue, handleChange }: Props) => {
  const renderRadioButtons = () => {
    return values.map((item, index) => {
      return (
        <FormControlLabel
          key={`radio-${index}`}
          value={item.value}
          control={<Radio />}
          label={options[index]}
          disabled={item.disabled}
        />
      );
    });
  };

  return (
    <ThemeProvider theme={materialTheme}>
      <StyledRadioForm>
        <FormLabel component="legend">{title}</FormLabel>
        <RadioGroup defaultValue={selectedValue} onChange={event => handleChange(event.target.value)}>
          {renderRadioButtons()}
        </RadioGroup>
      </StyledRadioForm>
    </ThemeProvider>
  );
};

export default RadioForm;
